import React from 'react'
import { useModel, useValue, WhenModelValue } from '@morningtrain/react-resources'
import VacationRequestEntry from 'pages/app/vacation/VacationRequestEntry'
import ToggleEntry from 'pages/app/vacation/ToggleEntry'
import ShiftEntry from 'pages/app/vacation/ShiftEntry'
import * as moment from 'moment'
import { useFilterMeta } from '@morningtrain/react-filters'

export default function Entry ({ from, to }) {
  const blockSize = 30

  const startDate = from

  const startAt = moment(useValue('start_at', null))

  const offset = startAt.diff(startDate.startOf('isoWeek'), 'days')
  const size = useValue('days', 1)

  const left = offset * blockSize
  const width = size * blockSize - 1

  const position = {
    left: left,
    width: width
  }

  return (
    <>
      <WhenModelValue name='entry_type' condition='vacation_request'>
        <VacationRequestEntry position={position} />
      </WhenModelValue>
      <WhenModelValue name='entry_type' condition='toggle'>
        <ToggleEntry position={position} />
      </WhenModelValue>
      <WhenModelValue name='entry_type' condition='shift'>
        <ShiftEntry position={position} />
      </WhenModelValue>
    </>
  )
}
